/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type QuizPackFormatDto = {
  /**
   * 퀴즈 아이템 타입
   */
  itemType: QuizPackFormatDto.itemType;
  /**
   * 선택지 수 (MULTIPLE_CHOICE 한정)
   */
  choiceCount?: number;
};
export namespace QuizPackFormatDto {
  /**
   * 퀴즈 아이템 타입
   */
  export enum itemType {
    MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
    TRUE_FALSE = "TRUE_FALSE",
    SHORT_ANSWER = "SHORT_ANSWER",
    VOCABULARY = "VOCABULARY",
  }
}
